/**
 * Datos de ejemplo — `stakingContractBridge` los devuelve hasta que leas el contrato Polygon.
 * Al integrar, mapea las respuestas on-chain al mismo shape (o ajusta los paneles una sola vez).
 */

export const MOCK_STAKING_PORTFOLIO = {
  totalValueLocked: '10,000.00',
  myStakesTotal: '1,500.00',
  mySharePercent: '0.15',
  walletBalance: '10,000.00',
  stakeTokenSymbol: 'USDC',
  minStake: '10',
  maxStake: '150',
};

export const MOCK_ACTIVE_STAKES = [
  {
    id: 'stake-1',
    amount: '1,000.00',
    stakeDate: '01/12/2024',
    dueDate: '01/12/2025',
    status: 'active',
  },
  {
    id: 'stake-2',
    amount: '500.00',
    stakeDate: '01/12/2024',
    dueDate: '01/12/2025',
    status: 'active',
  },
];

export const MOCK_UNSTAKE_SUMMARY = {
  availableToUnstake: '1,500.00',
  requested: '2,000.00',
  totalClaim: '500.00',
};

export const MOCK_UNSTAKE_ITEMS = [
  {
    id: 'u1',
    status: 'requested',
    amount: '500.00',
    stakeDate: '01/12/2024',
    dueDate: '01/04/2025',
    dueDateSecondary: '01/12/2025',
    penaltyFee: '100.00',
    drawDownLoss: '0.00',
  },
  {
    id: 'u2',
    status: 'available',
    amount: '500.00',
    stakeDate: '01/12/2024',
    dueDate: '01/04/2025',
    dueDateSecondary: '01/12/2025',
    penaltyFee: '50.00',
    drawDownLoss: '0.00',
    totalClaim: '450.00',
  },
  {
    id: 'u3',
    status: 'claimed',
    amount: '200.00',
    stakeDate: '01/12/2024',
    dueDate: '01/04/2025',
    dueDateSecondary: '01/12/2025',
    penaltyFee: '—',
    drawDownLoss: '—',
  },
];

const SAMPLE_TX =
  '0xd9df15e03c2b8b125cb9b0123456789abcdef0123456789abcdef01234567';

export const MOCK_STAKE_DETAIL = {
  id: 'stake-1',
  amount: '1,000.00',
  statusKey: 'completed',
  stakeDate: '01/12/2024',
  dueDate: '01/12/2025',
  countdown: { days: 120, hours: 10, minutes: 22, seconds: 3 },
  txHash: `${SAMPLE_TX.slice(0, 18)}…${SAMPLE_TX.slice(-8)}`,
  txHashFull: SAMPLE_TX,
  confirmations: '5',
  blockNumber: '33853937',
  explorerBaseUrl: 'https://polygonscan.com',
};
